// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"TemplateList-module__skeletonContainer--fU4Ip","templateHeader":"TemplateList-module__templateHeader--_jTSZ"};